// extracted by mini-css-extract-plugin
export var headline6 = "bv_dP";
export var menuContainer = "bv_dL";
export var menuItem = "bv_dN";
export var menuList = "bv_dM";